import Vue from 'vue'
import Vuex from 'vuex'
import request from '@/utils/request'
import { getToken } from '@/utils/auth'
import { asyncRouterMap } from '@/router/index'
import editBoxData from '@/utils/pageFormat'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    token: '',
    adminMessage: {},
    mainRoutes: [],
    baseurl: process.env.BASE_API + '/' + process.env.API_PREFIX,
    version: 'multi',
    page: {
      data: [],
      style: {},
      currentItem: ''
    },
    default_img_url: '/static/images/toux.png',
    articles: [],
    userRoutes: []
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_ADMIN_MESSAGE: (state, res) => {
      state.adminMessage = res
    },
    SET_MAIN_ROUTES: (state, routes) => {
      state.mainRoutes = routes
    },
    SET_USER_ROUTES: (state, routes) => {
      state.userRoutes = routes
    },
    SET_PAGE: (state, data) => {
      data = data || {
          style: {
            padding: 0
          },
          modules: []
        }
        
      state.page.data = data.modules
      state.page.style = data.style
    },
    SET_PAGE_CURRENTITEM: (state, data) => {
      state.page.currentItem = data
    },
    // SET_PAGE_EN: (state, data) => {
    //   state.page_en.data = data.modules
    //   state.page_en.style = data.style
    // },
    // SET_PAGE_CURRENTITEM_EN: (state, data) => {
    //   state.page_en.currentItem = data
    // },
    SET_PAGE_CURRENTITEM2: (state, data) => {
      state.page.data.forEach((item, index) => {
        if (item === state.page.currentItem) {
          state.page.data[index] = data
        }
      })
      state.page.currentItem = data
    },
    DELETE_PAGEITEM: (state, index) => {
      state.page.data.splice(index, 1)
    },
    ADD_PAGE_ITEM: (state, {index, type}) => {
      let item = JSON.parse(JSON.stringify(editBoxData[type]))
      state.page.data.splice(index, 0, item)
    }
  },
  getters: {
    token: state => state.token,
    getMainRoutes: state => state.mainRoutes,
    userRoutes: state => state.userRoutes
  },
  actions: {
    // 用户确认登录后获取用户信息
    GetAdminInfo: ({ commit, state, dispatch }) => {
      commit('SET_TOKEN', getToken())
      commit('SET_MAIN_ROUTES', asyncRouterMap)
      let response = request({
        url: 'admin',
        method: 'get'
      })
      return new Promise((resolve, reject) => {
        response.then(res => {
          commit('SET_ADMIN_MESSAGE', res.data.admin)
          dispatch('permissionsRoute', res.data.admin.permissions)
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    permissionsRoute: ({ commit, state }, permissions) => {
      let arr = []
      asyncRouterMap.forEach(item => {
        if (permissions.indexOf(item.name) > -1) {
          arr.push(item)
        }
      })
      commit('SET_USER_ROUTES', arr)
    },
    getUnread: ({ commit, state, getters }) => {
      request({
        url: 'unread',
        method: 'get'
      }, false).then(res => {
        getters.getMainRoutes.forEach(item => {
          let data = res.data
          if (item.name === 'order') {
            let total = 0
            for (let i = 0; i < item.children.length; i++) {
              if (item.children[i].name === 'orderList') {
                total = total + data.simple_order
                item.children[i].meta.badge = data.simple_order
              }
              if (item.children[i].name === 'groupBuyOrder') {
                total = total + data.group_buying_order
                item.children[i].meta.badge = data.group_buying_order
              }
              if (item.children[i].name === 'collectLikeOrder') {
                total = total + data.collect_like_order
                item.children[i].meta.badge = data.collect_like_order
              }
              if (item.children[i].name === 'movieOrder') {
                total = total + data.movie_order
                item.children[i].meta.badge = data.movie_order
              }
              if (item.children[i].name === 'videoOrder') {
                total = total + data.video_order
                item.children[i].meta.badge = data.video_order
              }
            }
            item.meta.badge = total
          }
          if (item.name === 'comment') {
            item.meta.badge = data.product_comment + data.page_comment + data.music_comment
            for (let i = 0; i < item.children.length; i++) {
              if (item.children[i].name === 'productComment') {
                item.children[i].meta.badge = data.product_comment
              }
              if (item.children[i].name === 'pageComment') {
                item.children[i].meta.badge = data.page_comment
              }
              if (item.children[i].name === 'musicComment') {
                item.children[i].meta.badge = data.music_comment
              }
            }
          }
        })
      })
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js